(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('MaterialFile', MaterialFile);

    MaterialFile.$inject = ['$resource'];

    function MaterialFile ($resource) {
        var resourceUrl =  'api/material-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
